import { Directive, ElementRef, HostListener, Input, inject } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'input[type="number"]',
  standalone: false
})
export class PreventNumberWheelDirective {
  private el = inject<ElementRef<HTMLInputElement>>(ElementRef);

  private _integerOnly = false;

  @Input()
  public set integerOnly(value: boolean) {
    this._integerOnly = value;
  }

  @HostListener('wheel', ['$event'])
  public onWheel(event: WheelEvent): void {
    const target = event.target as HTMLInputElement;
    // Only prevent number change if the input is focused, but allow scrolling
    if (target && target === document.activeElement && target.type === 'number') {
      event.preventDefault();
      // Manually scroll the page/window
      window.scrollBy({
        top: event.deltaY,
        left: event.deltaX,
        behavior: 'auto'
      });
    }
  }

  // Prevents being able to type dot in the input on native apps
  // Unlike keydown, beforeinput fires before the DOM changes and its preventDefault() is respected by mobile virtual keyboards
  @HostListener('beforeinput', ['$event'])
  public onBeforeInput(event: InputEvent): void {
    if (!this._integerOnly) {
      return;
    }

    if (event.data && /[^\d]/.test(event.data)) {
      event.preventDefault();
    }
  }

  @HostListener('keydown', ['$event'])
  public onKeyDown(event: KeyboardEvent): void {
    if (!this._integerOnly) {
      return;
    }

    const allowedKeys = [
      'Backspace',
      'Tab',
      'ArrowLeft',
      'ArrowRight',
      'Delete',
      'Home',
      'End',
      'Enter',
    ];

    const isShortcut =
      (event.ctrlKey || event.metaKey)
      && ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase());

    if (allowedKeys.includes(event.key) || isShortcut) {
      return;
    }

    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event'])
  public onInput(event: Event): void {
    if (!this._integerOnly) {
      return;
    }

    const inputEl = event.target as HTMLInputElement;
    const sanitized = inputEl.value.replace(/[^\d]/g, '');

    if (inputEl.value !== sanitized) {
      inputEl.value = sanitized;
    }
  }
}
